import ReactMarkdown from "react-markdown";
import { Text, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import type { ChatMessage } from "../useConversation";

const useStyles = makeStyles({
  row: {
    display: "flex",
    marginBottom: "12px",
  },
  rowUser: { justifyContent: "flex-end" },
  rowAssistant: { justifyContent: "flex-start" },
  bubble: {
    maxWidth: "80%",
    ...shorthands.padding("10px", "14px"),
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    lineHeight: tokens.lineHeightBase300,
    wordBreak: "break-word",
  },
  user: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
  },
  assistant: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground1,
  },
  markdown: {
    "& p": { ...shorthands.margin("0", "0", "8px", "0") },
    "& p:last-child": { marginBottom: 0 },
    "& ul, & ol": { ...shorthands.margin("4px", "0"), paddingInlineStart: "20px" },
    "& a": { color: "inherit", textDecorationLine: "underline" },
  },
  attachments: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "8px",
  },
  thumb: {
    width: "72px",
    height: "72px",
    objectFit: "cover",
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  fileChip: {
    ...shorthands.padding("4px", "8px"),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase200,
  },
});

export function MessageBubble({ message }: { message: ChatMessage }) {
  const styles = useStyles();
  const isUser = message.role === "user";

  return (
    <div className={`${styles.row} ${isUser ? styles.rowUser : styles.rowAssistant}`}>
      <div className={`${styles.bubble} ${isUser ? styles.user : styles.assistant}`}>
        {isUser ? (
          <Text>{message.content}</Text>
        ) : (
          <div className={styles.markdown}>
            <ReactMarkdown>{message.content}</ReactMarkdown>
          </div>
        )}
        {message.attachments && message.attachments.length > 0 && (
          <div className={styles.attachments}>
            {message.attachments.map((att, i) =>
              att.previewUrl ? (
                <img key={i} className={styles.thumb} src={att.previewUrl} alt={att.name} />
              ) : (
                <span key={i} className={styles.fileChip}>
                  {att.name}
                </span>
              ),
            )}
          </div>
        )}
      </div>
    </div>
  );
}
